import React, { useEffect, useState, Suspense, lazy } from "react";
import "@fontsource/poppins";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";
import axios from "axios";
import Loader from "./components/Loader";
import MediaQuery from "react-responsive";
import jsonData from "./ai-branding.json"; // Import the JSON file
const Navbar = lazy(() => import(".././src/components/PostEvent/Navbar"));
const Body = lazy(() => import(".././src/components/PostEvent/Body"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import('./components/Video/Video.js'));
const EventMemories = lazy(() => import('../src/components/PostEvent/EventMemories'));
const EventMemoriesMobile = lazy(() => import('.././src/components/PostEvent/EventMemoriesMobile.js'));
const PreMemories = lazy(() => import('../src/components/PostEvent/PreMemories'));
const PreMemoriesMobile = lazy(() => import('.././src/components/PostEvent/PreMemoriesMobile.js'));
const Experience = lazy(() => import(".././src/components/PostEvent/Experience.js"));
const SocialMedia = lazy(() => import(".././src/components/PostEvent/SocialMedia.js"));
const SocialMediaDesktop = lazy(() => import(".././src/components/PostEvent/SocialMediaDesktop.js"));
const Thankyou = lazy(() => import(".././src/components/PostEvent/Thankyou.js"));
const Blog = lazy(() => import(".././src/components/PostEvent/Blog.js"));
const SubscribeForEventNotifications = lazy(() =>  import("../src/components/PostEvent/SubscribeForEventNotifications.js"));


function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_MORGANROCKS_CDN_URL;

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
  return (
    <>
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    <div className="bodyContainer">
      <img src={imgCDNURL + "bg.webp"} className="waveimg img-fluid" 
                            alt="wave" />
       <img src={imgCDNURL + "small2.webp"} className="flower2 img-fluid" 
                            alt="Flower" />  
       <img src="https://d2b7dijo04ypct.cloudfront.net/morganrocks/dots-blue.webp" className="dot1"/>                                       
       {links ? (
    <>
       <Suspense fallback={<div />}> 
        <Navbar/>
      </Suspense>       
      <Suspense fallback={<div />}> 
        <Body handleVideo={handleVideo} videoToggle={videoToggle} links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}> 
        <Experience handleVideo={handleVideo} videoToggle={videoToggle}/>
      </Suspense>
      <MediaQuery minWidth={992}>
      <Suspense fallback={<div />}>
      <EventMemories />    
      </Suspense>     
      </MediaQuery>  
      <MediaQuery maxWidth={992}>
      <Suspense fallback={<div />}>
      <EventMemoriesMobile />
      </Suspense>     
      </MediaQuery>
      <MediaQuery maxWidth={991}>
      <Suspense fallback={<div />}>
      <SocialMedia links={links.current}/>
      </Suspense>     
      </MediaQuery>
      <MediaQuery minWidth={992}>
      <Suspense fallback={<div />}>
      <SocialMediaDesktop links={links.current}/>    
      </Suspense>     
      </MediaQuery> 
      <Suspense fallback={<div />}>
        <Blog links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Thankyou links={links.current}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <MediaQuery minWidth={992}>
      <Suspense fallback={<div />}>
      <PreMemories />    
      </Suspense>     
      </MediaQuery>  
      <MediaQuery maxWidth={992}>
      <Suspense fallback={<div />}>
      <PreMemoriesMobile />
      </Suspense>     
      </MediaQuery>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && <Video handleVideo={handleVideo} videoToggle={videoToggle}/>}
      </Suspense>
      </>
    ) : (
      <div>Loading...</div>
    )}
    </div>
    </>
  );
}

export default App;
